// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"beb_a bhi_rh bhi_ri bhi_vf bhi_ec bhi_vc bhi_gs bhi_kf"};